import { ICardFinalExamination } from './types'

import { IconClearClose } from '@img/icons'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { Flex, Modal, Loader, Input, Button, Textarea } from '@ui/index'

import css from './ui.module.scss'


/** Анкета итоговой работы */
const CardFinalExamination = ({
    isOpen, isLoadingCard, isDisableBtnSave, loadingTitle, isBtnToPrint, fullNameFrom, attestationType, dataBase, fieldsError, txtThemeIAR, txtBallIAR, txtBallTest,
    handlerOpenModalConfirm, handlerBtnSave, handleBtnClose
}: ICardFinalExamination) => {
    const isIT = attestationType === 'ИТ'
    const siteLogo = dataBase === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : dataBase === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    return <Modal isOpen={isOpen} isEsc onCancel={handleBtnClose} maxWidth='600px'>
        <Flex className='modal_container'>
            <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                <header>
                    <Flex gap='6px' flexDirection='row' alignItems='center'>
                        {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                        <h4>Анкета итоговой работы</h4>
                    </Flex>

                    <h5>{fullNameFrom}</h5>
                </header>

                <Button variant='icon' size='md' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Loader isOpen={isLoadingCard} title={loadingTitle.value} backdrop />

                <Flex gap='15px' className='modal_container-content'>
                    {!isIT && (
                        <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                            <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.themeIAR ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Тема итоговой аттестационной работы <p className='pulse'></p></Flex>
                                <Textarea placeholder="Тема итоговой аттестационной работы" rows={4} value={txtThemeIAR.value} onChange={(e) => txtThemeIAR.setValue(e.target.value)} />
                            </Flex>
                        </Flex>
                    )}

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        {!isIT && (
                            <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.ballIAR ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Балл по работе <p className='pulse'></p></Flex>
                                <Input placeholder="Балл по работе" paddingRight='4px' {...txtBallIAR} />
                            </Flex>
                        )}

                        {isIT && (
                            <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.ballTest ? 'input_error' : 'input_error input_error-active'}>
                                <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Балл по тесту <p className='pulse'></p></Flex>
                                <Input placeholder="Балл по тесту" paddingRight='4px' {...txtBallTest} />
                            </Flex>
                        )}
                    </Flex>
                </Flex>

                <Flex gap='6px' flexDirection='row' flexWrap='wrap' justifyContent='space-between'>
                    <Button variant='primaryDark' flexGrow={1} flexBasis='100px' isVisible={isBtnToPrint.value === 1}
                        onClick={() => handlerOpenModalConfirm(true, 'На печать', `Вы действительно хотите отправить в печать данного слушателя:<br />👉 ${fullNameFrom}.`, 'toPrint')}
                    >В печать</Button>
                    <Button variant='primaryDark' flexGrow={1} flexBasis='100px' 
                        onClick={() => handlerOpenModalConfirm(true, 'Отправка в архив', `Вы действительно хотите отправить в архив данного слушателя:<br />👉 ${fullNameFrom}.`, 'inArchive')}
                    >В архив</Button>

                    <Button flexGrow={1} flexBasis='140px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handlerBtnSave(true)}>Сохранить и закрыть</Button>
                    <Button flexGrow={1} flexBasis='100px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handlerBtnSave(false)}>Сохранить</Button>
                </Flex>
            </Flex>
        </Flex>
    </Modal>
}

export default CardFinalExamination